import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatRadioChange } from '@angular/material/radio';

export enum EForwardType {
  ACCOUNT,
  RECIPIENTS
}

@Component({
  selector: 'app-forward-dialog',
  templateUrl: './forward-dialog.component.html',
  styleUrls: ['./forward-dialog.component.scss'],
})
export class ForwardDialogComponent implements OnInit {

  messageId: number;

  inputForm: FormGroup;

  forwardTypes = EForwardType;

  componentReady = false;

  constructor() {
  }

  get forwardType(): AbstractControl {
    return this.inputForm.get('forward_type');
  }

  ngOnInit(): void {
    if (this.inputForm) {
      this.inputForm.addControl('forward_type', new FormControl(EForwardType.ACCOUNT, [Validators.required]));
      this.inputForm.addControl('recipients', new FormControl('', [Validators.email]));
      this.inputForm.addControl('contact_details', new FormControl(false, Validators.required));
      this.componentReady = true;
    }
  }

  onForwardChange($event: MatRadioChange) {
    if ($event.value === EForwardType.RECIPIENTS) {
      this.inputForm.get('recipients').setValidators([Validators.required, Validators.email]);
      return;
    }

    this.inputForm.get('recipients').removeValidators([Validators.required]);
  }

}
